import React from 'react';
import Form from 'react-bootstrap/Form';
import { formatAssigneeOptionLabel } from '../../utils/ocRequest';

/**
 * Lab-user picker for OC stage assignees.
 * Primary label: full_name || username; secondary: email in option text.
 *
 * @param {Object} props
 * @param {number|null} props.value
 * @param {(id: number|null) => void} props.onChange
 * @param {string} [props.label]
 * @param {Array<{id: number, full_name?: string, username?: string, email?: string}>} props.options
 * @param {boolean} [props.disabled]
 * @param {string} [props.emptyLabel]
 * @param {string} [props.controlId]
 */
const AssigneeUserSelect = ({
  value,
  onChange,
  label,
  options = [],
  disabled = false,
  emptyLabel = 'Unassigned (use group / defaults)',
  controlId,
}) => {
  const selectValue = value == null || value === '' ? '' : String(value);

  return (
    <Form.Group controlId={controlId} className="mb-2">
      {label ? <Form.Label>{label}</Form.Label> : null}
      <Form.Select
        value={selectValue}
        disabled={disabled}
        onChange={e => {
          const raw = e.target.value;
          if (!raw) {
            onChange?.(null);
            return;
          }
          const id = Number(raw);
          onChange?.(Number.isFinite(id) ? id : null);
        }}
      >
        <option value="">{emptyLabel}</option>
        {options.map(user => {
          const primary = formatAssigneeOptionLabel(user) || `User ${user.id}`;
          const email = String(user.email || '').trim();
          return (
            <option key={user.id} value={String(user.id)}>
              {email ? `${primary} (${email})` : primary}
            </option>
          );
        })}
      </Form.Select>
    </Form.Group>
  );
};

export default AssigneeUserSelect;
